import React from 'react';

import './ExpandAll.scss';

function ExpandAll({
  isExpanded, setIsExpanded,
}) {
  const title = isExpanded ? 'Collapse all -' : 'Expand all +';

  return (
    <button
      aria-expanded={isExpanded}
      className="mn_expandAll"
      onClick={() => setIsExpanded(!isExpanded)}
    >
      {title}
    </button>
  );
}

export default ExpandAll;
